import { Capacitor } from "@capacitor/core";
import { createDexieStore } from "../storage/dexie";
import { createMemoryStore } from "../storage/memory";
import { createSqliteStore, openCapacitorSqlite } from "../storage/sqlite";
import type { LocalStore } from "../storage/types";

export const isNative = () => Capacitor.isNativePlatform();

/** Where the API lives: same origin on the web, VITE_API_URL inside native apps. */
export function apiBaseUrl(): string {
  return (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") ?? "";
}

/** Pick the best local store for this platform, falling back so the app always opens. */
export async function openStore(native = isNative()): Promise<LocalStore> {
  try {
    if (native) return await createSqliteStore(await openCapacitorSqlite());
    if (typeof indexedDB !== "undefined") return createDexieStore();
  } catch (err) {
    console.error("Local storage unavailable, using memory", err);
  }
  return createMemoryStore();
}

/** Bearer token storage for native apps (cookies handle the web). */
export const tokenStore = {
  get: (): string | null => {
    try {
      return localStorage.getItem("hexling.token");
    } catch {
      return null;
    }
  },
  set: (token: string | null) => {
    try {
      if (token) localStorage.setItem("hexling.token", token);
      else localStorage.removeItem("hexling.token");
    } catch {
      /* storage blocked: session falls back to cookies */
    }
  },
};
